var TabNewGeneralModule = /** @class */ (function () {
    function TabNewGeneralModule() {
    }
    return TabNewGeneralModule;
}());
export { TabNewGeneralModule };
